import React, { useEffect, useState } from 'react';
import { Select } from 'antd';

import { AccessRuleGroup } from '../../../common/constants/types';
import { simpleFetch } from '../../../common/utils/http';

interface Props {
  value?: string;
}

const AccessRuleGroupSelect = ({ value, ...props }: Props) => {
  const [accessRuleGroups, setAccessRuleGroups] = useState<AccessRuleGroup[]>([]);
  useEffect(() => {
    simpleFetch('/api/v1/access-rule-groups').then(args => setAccessRuleGroups(args));
  }, []);

  return (
    <Select value={value} {...props}>
      {accessRuleGroups
        .sort((a, b) => a.id - b.id)
        .map(arg => (
          <Select.Option key={arg.id} value={arg.id}>
            {arg.id} - {arg.name}
          </Select.Option>
        ))}
    </Select>
  );
};

export default AccessRuleGroupSelect;
